// extracted by mini-css-extract-plugin
export default {"badges":"NotificationBadges_badges__aXU69","badge":"NotificationBadges_badge__0c04U","important":"NotificationBadges_important__JZXQv","new":"NotificationBadges_new__THdVi"};